<script>
    import { changeData } from '@/scripts/tools';

    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            addData() {return this.$store.getters.PROMPT_DATA_ADD},
        },
        methods: {
            async updateData(event, fieldName, isCheckBox = false) {
                this.errorText = await changeData(
                    event, fieldName, 'PROMPT_DATA_ADD_UPDATE', 'CHECK_PROMPT_ADD', isCheckBox
                );
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input
            :value="addData['name']"
            @change="updateData($event, 'name')"
            type="text"
            class="right_input mt_5 mb_10"
        >
        <label>Prompt Body:</label>
        <textarea
            :value="addData['body']"
            @change="updateData($event, 'body')"
            class="right_input mt_5 mb_10"
        ></textarea>
        <label>Prompt Exclude Words:</label>
        <textarea
            :value="addData['promt_exclude_words']"
            @change="updateData($event, 'promt_exclude_words')"
            class="right_input mt_5 mb_10"
        ></textarea>
        <label>Programm Exclude Words:</label>
        <textarea
            :value="addData['programm_exclude_words']"
            @change="updateData($event, 'programm_exclude_words')"
            class="right_input mt_5"
        ></textarea>

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>